@if (content) {
  <app-layout-default>
    <app-contact-us [content]="content.contactUs"></app-contact-us>
    <app-checklist [checklistContentInput]="content.giftingIneligibleDesc.giftingIneligibleDescList"
      [showPhoneNumber]="false">
    </app-checklist>
    <div layout-last-column>
      <c11n-button id="ineligibleBTN" (clickEvent)="learnMore()" [labelText]="content.buttonLabel" fullWidth="true">
      </c11n-button>
      <app-feedback-survey></app-feedback-survey>
    </div>
  </app-layout-default>
}
